// extracted by mini-css-extract-plugin
export default {"root":"WishlistToggle_root__DLXzC"};